import { LoginBox } from "../components/loginBox";
import { Header1, P } from "../components/headers";
import userBrowserLanguage from "../components/userBrowserLanguage";
import getTranslationJson from "../components/getTranslationJson";
import SvgIcon from "../components/SvgIcon";

function NotFound404() {
  const translation = getTranslationJson(userBrowserLanguage());

  return (
    <div className="font-inter-24">
      <LoginBox>
        <header className="fflex flex-col mb-6 items-center justify-center">
          <Header1>{translation.not_found_404 || "Page not Found 404"}</Header1>
          <P>{translation.not_found_404_description || "Sorry, we couldn't find the page you were looking for."}</P>
        </header>
        <>
          <div className="flex items-center justify-center">
            <SvgIcon
              name="dental-broken-tooth"
              className=" text-3xl text-brand-green bg-green-50 rounded-[40px] mb-2 p-3 w-20 h-20"
            />
          </div>

          {/* <div className="text-sm text-gray-600 mb-4">
            {translation.email_verification_successfull_description ||
              "You can now close this window and return to the login screen."}
          </div> */}
        </>
      </LoginBox>
    </div>
  );
}
export default NotFound404;
